import {
	bettoHistoryBodyBackground,
	getBettoHistoryStatusStyles,
	isBettoHistoryTenant,
} from "@pages/profile-v2/betto/shared/bettoHistoryStyles";
import { BTTO_PROFILE_COLORS } from "@pages/profile-v2/betto/shared/elements";
import styled, { css } from "styled-components";

const ContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	padding: ${isBettoHistoryTenant ? "0" : "5px 0px"};
	align-items: flex-start;
	align-self: stretch;
	border-radius: ${isBettoHistoryTenant ? "12px" : "15px"};
	background: ${isBettoHistoryTenant
		? BTTO_PROFILE_COLORS.surfaceRaised
		: "var(--input-bg-has-value)"};
	border: ${isBettoHistoryTenant ? `1px solid ${BTTO_PROFILE_COLORS.border}` : "none"};
	overflow: hidden;
	margin-bottom: ${isBettoHistoryTenant ? "12px" : "0"};

	&:last-child {
		margin-bottom: 0;
	}
`;

const ContentHeader = styled.div`
	display: flex;
	padding: ${isBettoHistoryTenant ? "12px 14px 8px" : "5px 10px"};
	justify-content: space-between;
	align-items: center;
	align-self: stretch;
	gap: 12px;
`;

const Date = styled.div`
	color: ${isBettoHistoryTenant ? BTTO_PROFILE_COLORS.textMuted : "var(--secondary-text-color)"};
	font-size: ${isBettoHistoryTenant ? "12px" : "10px"};
	font-weight: ${isBettoHistoryTenant ? "500" : "600"};
	line-height: ${isBettoHistoryTenant ? "1.4" : "12px"};
	letter-spacing: 0.3px;

	@media (min-width: 768px) {
		font-size: 12px;
		line-height: 20px;
	}
`;

const HeaderTitle = styled.div`
	border-radius: 50px;
	display: flex;
	min-height: 24px;
	padding: ${isBettoHistoryTenant ? "4px 10px" : "9px 10px"};
	justify-content: center;
	align-items: center;
	gap: 12px;
	color: #fcfcfc;
	text-align: center;
	font-size: ${isBettoHistoryTenant ? "11px" : "10px"};
	font-weight: 600;
	line-height: 1.2;
	letter-spacing: 0.3px;
	text-transform: capitalize;
	flex-shrink: 0;

	@media (min-width: 768px) {
		font-size: 12px;
		line-height: 20px;
	}

	${({ status }) =>
		isBettoHistoryTenant
			? getBettoHistoryStatusStyles(status)
			: status &&
				css`
					background: ${status === "Completed"
						? "linear-gradient(180deg, #18BB0C 0%, #067306 100%)"
						: status === "Rejected"
							? "linear-gradient(180deg, #F0052F 0%, #940136 100%)"
							: "#6e7191"};
				`}
`;

const ContentBody = styled.div`
	display: flex;
	padding: ${isBettoHistoryTenant ? "10px 14px" : "5px 10px"};
	justify-content: center;
	align-items: center;
	align-self: stretch;
	background: ${isBettoHistoryTenant
		? bettoHistoryBodyBackground
		: "var(--content-body-gradient)"};
	color: ${isBettoHistoryTenant ? BTTO_PROFILE_COLORS.text : "var(--content-text-color)"};
	text-align: center;
	font-size: 12px;
	font-weight: 600;
	line-height: 20px;
	letter-spacing: 0.3px;
	text-transform: uppercase;
`;

const DetailsButton = styled.div`
	display: flex;
	width: 100%;
	justify-content: center;
	align-items: center;
	gap: 6px;
	padding: ${isBettoHistoryTenant ? "10px 12px" : "0"};
	border-top: 1px solid
		${isBettoHistoryTenant ? BTTO_PROFILE_COLORS.border : "var(--header-color)"};
	cursor: pointer;
	transition: background 0.2s ease;

	${isBettoHistoryTenant &&
	css`
		&:hover {
			background: ${BTTO_PROFILE_COLORS.surfaceHover};
		}
	`}

	svg {
		path {
			stroke: ${isBettoHistoryTenant ? BTTO_PROFILE_COLORS.primary : "var(--header-color)"};
		}
	}

	${({ rotate }) =>
		rotate &&
		css`
			svg {
				transform: rotate(180deg);
				animation: rotate 0.1s;
			}
		`}
`;

const ButtonText = styled.div`
	display: flex;
	color: ${isBettoHistoryTenant ? BTTO_PROFILE_COLORS.primary : "var(--header-color)"};
	text-align: center;
	font-size: ${isBettoHistoryTenant ? "12px" : "10px"};
	font-weight: ${isBettoHistoryTenant ? "600" : "400"};
	line-height: ${isBettoHistoryTenant ? "1.2" : "12px"};
	letter-spacing: 0.3px;
	min-width: 42px;
	justify-content: flex-end;
	text-transform: uppercase;

	@media (min-width: 768px) {
		font-size: 12px;
		line-height: 20px;
	}
`;

const ContentFooter = styled.div`
	display: flex;
	width: 100%;
	padding: ${isBettoHistoryTenant ? "0 14px 12px" : "10px"};
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;
	gap: 8px;
	align-self: stretch;
	border-top: ${isBettoHistoryTenant ? `1px solid ${BTTO_PROFILE_COLORS.border}` : "none"};
`;

const FooterInfoWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	width: 100%;
	gap: 12px;
`;

const CopyId = styled.div`
	flex: 1;
	display: flex;
	align-items: center;
	gap: 4px;
	color: ${isBettoHistoryTenant
		? BTTO_PROFILE_COLORS.textMuted
		: "var(--main-secondary-text-color)"};
	font-size: ${isBettoHistoryTenant ? "11px" : "10px"};
	font-weight: 600;
	line-height: 1.3;
	letter-spacing: 0.3px;
	min-height: 20px;
	padding: 2px 0px;
	text-transform: uppercase;

	@media (min-width: 768px) {
		font-size: 12px;
		line-height: 20px;
	}

	svg {
		cursor: pointer;

		path {
			fill: ${isBettoHistoryTenant
				? BTTO_PROFILE_COLORS.textMuted
				: "var(--main-secondary-text-color)"};
		}
	}
`;

const Id = styled.div`
	display: flex;
	color: ${isBettoHistoryTenant ? BTTO_PROFILE_COLORS.text : "var(--main-secondary-text-color)"};
	font-size: ${isBettoHistoryTenant ? "11px" : "10px"};
	font-weight: 600;
	line-height: 1.3;
	letter-spacing: 0.3px;

	@media (min-width: 768px) {
		font-size: 12px;
		line-height: 20px;
	}
`;

const BonusInfo = styled.div`
	align-items: center;
	display: flex;
	flex: 1;
	min-height: 20px;
	padding: 2px 0px;
	color: ${isBettoHistoryTenant
		? BTTO_PROFILE_COLORS.textMuted
		: "var(--main-secondary-text-color)"};
	text-align: center;
	font-size: ${isBettoHistoryTenant ? "11px" : "10px"};
	font-weight: 600;
	line-height: 1.3;
	letter-spacing: 0.3px;
	justify-content: flex-end;
	text-transform: uppercase;

	@media (min-width: 768px) {
		font-size: 12px;
		line-height: 20px;
	}
`;

const FriendInfo = styled.div`
	align-items: center;
	display: flex;
	flex: 1;
	min-height: 20px;
	padding: 2px 0px;
	color: ${isBettoHistoryTenant
		? BTTO_PROFILE_COLORS.textMuted
		: "var(--main-secondary-text-color)"};
	text-align: center;
	font-size: ${isBettoHistoryTenant ? "11px" : "10px"};
	font-weight: 600;
	line-height: 1.3;
	letter-spacing: 0.3px;
	justify-content: center;
	text-transform: uppercase;

	@media (min-width: 768px) {
		font-size: 12px;
		line-height: 20px;
	}
`;

const Note = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	min-height: 20px;
	padding: 2px 0px;
	flex: 1;
	color: ${isBettoHistoryTenant
		? BTTO_PROFILE_COLORS.textDim
		: "var(--main-secondary-text-color)"};
	text-align: center;
	font-size: ${isBettoHistoryTenant ? "11px" : "10px"};
	font-weight: 500;
	line-height: 1.3;
	letter-spacing: 0.3px;
	text-transform: uppercase;

	@media (min-width: 768px) {
		font-size: 12px;
		line-height: 20px;
	}
`;

export {
	BonusInfo,
	ButtonText,
	ContentBody,
	ContentFooter,
	ContentHeader,
	ContentWrapper,
	CopyId,
	Date,
	DetailsButton,
	FooterInfoWrapper,
	FriendInfo,
	HeaderTitle,
	Id,
	Note,
};
